import { makeStyles, Theme } from '@material-ui/core';

export const useRegisterFormHeaderStyles = makeStyles((theme: Theme) => ({
    container: {
        paddingBottom: '36px',
    },
}));
